import { EventEmitter, Input, Output, Directive } from '@angular/core';
import { InputConfig } from './advanced-inputs.model';

@Directive()
export abstract class AbstractAdvancedInput {
  @Input() configuration: InputConfig;
  @Input() set currentValue(val: any) {
    this._value = val;
  }
  @Output() currentValueChange = new EventEmitter<any>();

  public get value(): any {
    return this._value;
  }
  public set value(val: any) {
    if (this._value === val && !this.configuration?.alwaysEmitChanges) {
      return;
    }
    this._value = val;
    this.currentValueChange.emit(this._value);
  }

  public _value: any = null;
}
